import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import BaseUrl from "../../Components/BaseUrl";
import Swal from 'sweetalert2';
const DiscoverGroups = () => {
  //   const groups = [
  //     {
  //       id: 1,
  //       name: "Compagnia del buon Lavoro",
  //       description:
  //         "La Compagnia del buon Lavoro® è un Movimento Open Source che si adopera gratuitamente...",
  //       type: "public",
  //       members_count: "71K",
  //       logo: "https://via.placeholder.com/50?text=CL",
  //     },
  //     {
  //       id: 2,
  //       name: "PIC/S GMP Industry Forum",
  //       description:
  //         "A professional forum to discuss and debate the globalisation of pharmaceutical GMP...",
  //       type: "private",
  //       members_count: "71K",
  //       logo: "https://via.placeholder.com/50?text=PF",
  //     },
  //     {
  //       id: 3,
  //       name: "Juniper Networks Training and Certification",
  //       description:
  //         "The official discussion group for Juniper Networks training, certification, and jobs...",
  //       type: "public",
  //       members_count: "71K",
  //       logo: "https://via.placeholder.com/50?text=JN",
  //     },
  //     {
  //       id: 4,
  //       name: "LGPD - enfoque: jurídico, marketing, TI",
  //       description:
  //         "Criado em setembro de 2019 com a intenção de divulgar o material da primeira aula...",
  //       type: "private",
  //       members_count: "70K",
  //       logo: "https://via.placeholder.com/50?text=LG",
  //     },
  //     {
  //       id: 5,
  //       name: "EMPLEO IT LATAM",
  //       description:
  //         "El objetivo del grupo es la publicación de vacantes relacionadas con ofertas del sector tecnológico...",
  //       type: "public",
  //       members_count: "71K",
  //       logo: "https://via.placeholder.com/50?text=IT",
  //     },
  //   ];
  const [groups, setGroups] = useState([]);
  const [groupCount, setGroupCount] = useState(0);
  const [isloading, setIsLoading] = useState(false);

  const fetchGroups = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + "getallgroups", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(response.data);
      setGroupCount(response.data.data.total);
      setGroups(response.data.data.groups);
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleJoin = async (group) => {
   
    try {
      const response = await axios.post(
        BaseUrl + `joingroup/${group.slug}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        if(group.type === "Private"){
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Request sent successfully!',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
        else{
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Joined successfully!',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
        fetchGroups(); 
      }
    } catch (error) {
      console.error("Join request failed:", error);
    }
  };
  const withdrawrequest = async (group) => {
   
    try {
      const response = await axios.post(
        BaseUrl + `withdrawrequest/${group.slug}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Request withdraw successfully!',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        fetchGroups(); 
      }
    } catch (error) {
      console.error("Join request failed:", error);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-14 ">
          <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-3/4">
              <p className="text-sm text-gray-500 mb-4 ml-1">
                About {groupCount} results
              </p>
              <div className="bg-white border  rounded-t-lg mb-4 p-4">
                <h2 className="text-2xl font-bold mb-4">Discover Groups</h2>
                {groups.map((group) => (
                  <div
                    key={group.id}
                    className="bg-white rounded-lg border p-4 mb-4 shadow-sm flex justify-between items-start"
                  >
                    {/* Left: Image + Info */}
                    <Link to={`/groups/${group.slug}`}>
                      <div className="flex gap-4">
                        <img
                          src={group.logo || "/default-logo.png"}
                          alt={group.name}
                          className="w-14 h-14 object-contain rounded"
                        />
                        <div>
                          <p className="text-md font-semibold text-blue-700 hover:underline">
                            {group.name}
                          </p>
                          <p className="text-sm text-gray-600">
                            {group.members_count} members
                          </p>
                          <p className="text-sm mt-1 text-gray-700 line-clamp-2">
                            {group.description}
                          </p>
                        </div>
                      </div>
                    </Link>

                    {/* Right: Join Button */}
                    {group.is_connected === "connected" ? (
                      <button className="text-blue-600 border border-blue-600 px-4 py-1.5 rounded-full font-medium hover:bg-blue-50 transition whitespace-nowrap">
                        <Link to={`/groups/${group.slug}`}>Visit group</Link>
                      </button>
                    ) : group.is_connected === "pending" ? (
                      <button
                        onClick={() => withdrawrequest(group)}
                        className="text-blue-600 border border-blue-600 px-4 py-1.5 rounded-full font-medium hover:bg-blue-50 transition whitespace-nowrap"
                      >
                        Pending
                      </button>
                    ) : (
                      <button
                        onClick={() => handleJoin(group)}
                        className="text-blue-600 border border-blue-600 px-4 py-1.5 rounded-full font-medium hover:bg-blue-50 transition whitespace-nowrap"
                      >
                        Join
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full lg:w-1/4 mt-9">
              <div className="bg-white rounded-lg border ">
                <h2 className="text-lg text-black font-normal  border-b border-gray-300 px-4 py-2">
                  Manage my network
                </h2>
                <div className="space-y-6 text-lg text-gray-600 overflow-hidden0">
                  <Link to="/user/networks/connections">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-user-friends mr-2"></i>
                      <p>Connections</p>
                    </div>
                  </Link>
                  <Link to="/user/networks/following-followers">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-user-plus mr-2"></i>
                      <p>Following & Followers</p>
                    </div>
                  </Link>
                  <Link to="/groups">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-users mr-2"></i>
                      <p>Groups</p>
                    </div>
                  </Link>
                  <Link to="/events">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-calendar-alt mr-4"></i>
                      <p>Events</p>
                    </div>
                  </Link>
                  <Link to="/pages">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-newspaper mr-3"></i>
                      <p>Pages</p>
                    </div>
                  </Link>
                  <Link to="/newsletters">
                    <div className="flex items-center gap-2 hover:bg-gray-200 px-4 py-2">
                      <i className="fas fa-newspaper mr-3"></i>
                      <p>Newsletters</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DiscoverGroups;
